// 给action注册事件处理函数。当这个函数被触发时候，将状态提交到mutations中处理


//点击切换到中文
export function changeZH({commit}) { 
    return commit ('changeZH')
}
//点击切换到英文
export function changeEN({commit}) { 
    return commit ('changeEN')
}
//最开始lang css状态
export function changeLangCss({commit}) { 
    return commit ('changeLangCss')
}
//二级菜单展示
export function changeShow({commit}) { 
    return commit ('changeShow')
}
//用户信息
export function setUser({commit},user) { 
    return commit ('setUser',user)
}
//退出登录
export function quitUser({commit}) { 
    return commit ('quitUser')
}
//切换登录方式
export function loginWay({commit}) { 
    return commit ('loginWay')
}
//获取选中的nav的名字
export function setNavName({commit},name) { 
    return commit ('setNavName',name)
}
//个人信息档案
export function userMsg({commit},data) { 
    return commit ('userMsg',data)
}
//获取体检人列表
export function getPhysical({commit}) { 
    return commit ('getPhysical')
}

//message提示
export function message({commit},data) { 
    return commit ('message',data)
}
//额度明细接口
export function quotaDetails({commit}) { 
    return commit ('quotaDetails')
}






// WEBPACK FOOTER //
// ./src/store/actions.js